/**
 * The lead chat's code chunk (decision 0029: its own lazy chunk, so the home and settings pages don't load it). One
 * loader for the page's `lazy()` and for the early preload (project load speed, 2026-10-17): a project opened on its
 * Chat tab fetches the chunk while the project's snapshot is still on its way, not after it.
 */
export const loadChatView = () => import("@/features/chat/chat-view")

/** Start loading the chat's chunk now; a failure is left to the page's own `lazy()` (it retries and shows the error). */
export const preloadChatView = (): void => {
  loadChatView().catch(() => {})
}
